<!--
 * @Autor: songqiangqiang
 * @Date: 2021-07-30 11:06:24
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-08-21 17:00:24
 * @FilePath: /app-teacher-h5/src/components/Lottie/Lottie.vue
 * @description:
-->
<template>
  <div :style="style" ref="lavContainer" />
</template>

<script>
import lottie from 'lottie-web'
export default {
  name: 'Lottie',
  props: {
    options: {
      type: Object,
      required: true
    },
    height: {
      type: Number,
      default: null
    },
    width: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      style: {
        width: this.width ? `${this.width}px` : '20px',
        height: this.height ? `${this.height}px` : '20px',
        overflow: 'hidden'
      }
    }
  },
  watch: {
    options: {
      handler() {
        this.init()
      },
      deep: true
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.anim && this.anim.destroy()
      this.anim = lottie.loadAnimation({
        container: this.$refs.lavContainer,
        renderer: 'svg',
        loop: this.options.loop !== false,
        autoplay: this.options.autoplay !== false,
        animationData: this.options.animationData,
        rendererSettings: this.options.rendererSettings
      })
      this.$emit('animCreated', this.anim)
    }
  }
}
</script>